import * as ambassadorWixRicosV1EmbeddableItem from './ricos-v1-embeddable-item-ricos-embeddables.http.js';
import * as ambassadorWixRicosV1EmbeddableItemTypes from './ricos-v1-embeddable-item-ricos-embeddables.types.js';
import * as ambassadorWixRicosV1EmbeddableItemUniversalTypes from './ricos-v1-embeddable-item-ricos-embeddables.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getEmbeddableItem(): __PublicMethodMetaInfo<
  'GET',
  { embeddableItemId: string },
  ambassadorWixRicosV1EmbeddableItemUniversalTypes.GetEmbeddableItemRequest,
  ambassadorWixRicosV1EmbeddableItemTypes.GetEmbeddableItemRequest,
  ambassadorWixRicosV1EmbeddableItemUniversalTypes.GetEmbeddableItemResponse,
  ambassadorWixRicosV1EmbeddableItemTypes.GetEmbeddableItemResponse
> {
  const payload = { embeddableItemId: ':embeddableItemId' } as any;

  const getRequestOptions =
    ambassadorWixRicosV1EmbeddableItem.getEmbeddableItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/embeddable-items/{embeddableItemId}',
    pathParams: { embeddableItemId: 'embeddableItemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listEmbeddableItems(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRicosV1EmbeddableItemUniversalTypes.ListEmbeddableItemsRequest,
  ambassadorWixRicosV1EmbeddableItemTypes.ListEmbeddableItemsRequest,
  ambassadorWixRicosV1EmbeddableItemUniversalTypes.ListEmbeddableItemsResponse,
  ambassadorWixRicosV1EmbeddableItemTypes.ListEmbeddableItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRicosV1EmbeddableItem.listEmbeddableItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/embeddable-items/list',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  EmbeddableItem as EmbeddableItemOriginal,
  EmbeddableItemItemTypeDetailsOneOf as EmbeddableItemItemTypeDetailsOneOfOriginal,
  Image as ImageOriginal,
  PricingData as PricingDataOriginal,
  ItemType as ItemTypeOriginal,
  ItemTypeWithLiterals as ItemTypeWithLiteralsOriginal,
  BookingDetails as BookingDetailsOriginal,
  EventDetails as EventDetailsOriginal,
  GetEmbeddableItemRequest as GetEmbeddableItemRequestOriginal,
  GetEmbeddableItemResponse as GetEmbeddableItemResponseOriginal,
  ListEmbeddableItemsRequest as ListEmbeddableItemsRequestOriginal,
  CursorPaging as CursorPagingOriginal,
  ListEmbeddableItemsResponse as ListEmbeddableItemsResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
} from './ricos-v1-embeddable-item-ricos-embeddables.types.js';
